
export function setsEqual<T>(a: Iterable<T>, b: Iterable<T>) {
  let tracker = new Map<string, number>();

  for (let i of a) {
    let key = '' + i + typeof i;

    tracker.set(key, 1);
  }

  for (let i of b) {
    let key = '' + i + typeof i;

    if (!tracker.has(key))
      return false;

    tracker.set(key, 2);
  }


  for (let value of tracker.values()) {
    if (value !== 2)
      return false;
  }

  return true;
}
